import React from 'react';
import Slideshow from './FestivalSlider/Slideshow';

const FestivalSlider = () => {
	console.log('adsasda');
	return (
		<div>
			<Slideshow />
		</div>
	);
};

export default FestivalSlider;
